export const EtatDemandeEnums = {
    INITIEE: "INITIEE",
    APPROUVEE: "APPROUVEE",
    ACCEPTEE: "ACCEPTEE",
    REJETEE: "REJETEE"
}